export enum MaritalStatus {
  Married = 'Marié(e)',
  PACS = 'PACS',
  MarriedLife = 'Vie Maritale',
  Single = 'Célibataire',
  Divorced = 'Divorcé(e)',
  Separated = 'Séparé(e)',
  DeFactoSeparated = 'Séparé(e) de fait',
  Widowed = 'Veuf(ve)',
  NI = 'NI',
}

export const labelsByMaritalStatus: Map<MaritalStatus, string> = new Map<MaritalStatus, string>(
  Object.keys(MaritalStatus).map((x: string) => [x, MaritalStatus[x]] as [MaritalStatus, string]),
);
